import classnames from 'classnames';
import { CustomEventName, GTMEventKey } from '@/utils/gtm';
import Link from 'next/link';
import React from 'react';
import ImprovePlacementGTM from '../ImprovePlacementGTM';

interface SectionProperty {
  className?: string;
  title: string;
  readMore?: string;
  enabledGTM?: boolean;
  rightContent?: React.ReactNode;
  readMoreTarget?: '_blank' | '_self';
}

export const Section: React.FC<SectionProperty> = ({
  className,
  title,
  readMore,
  enabledGTM = false,
  rightContent,
  readMoreTarget = '_blank'
}) => {
  // 滑動到標題時，送GTM IMP_PLACEMENT事件
  const gtmEvent = {
    [GTMEventKey.EVENT_NAME]: CustomEventName.IMP_PLACEMENT,
    [GTMEventKey.SECTION]: `%p_${title}`
  };

  return (
    <div className='flex items-center justify-between'>
      <h3
        className={classnames(
          "tracking-[.5px]text-black relative left-0 top-0 inline-block pl-[23px] text-[22px] font-semibold leading-none before:absolute before:inline-block before:h-[22px]  before:w-[5px] before:translate-x-[-21px] before:bg-[#e03f19] before:content-['']",
          className
        )}
      >
        {title}
      </h3>
      {enabledGTM && <ImprovePlacementGTM gtmEvent={gtmEvent} />}
      {readMore && (
        <Link
          href={readMore}
          className='mr-4 text-[13px] text-[#e03f19] after:ml-1 after:content-read-more lg:mr-0'
          target={readMoreTarget}
        >
          看更多
        </Link>
      )}
      {rightContent && rightContent}
    </div>
  );
};
